// extracted by css-extract-rspack-plugin
export default {"tooltipContent":"MyTasksContainer_tooltipContent__UVES9"};